import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-challenges',
  templateUrl: './challenges.component.html',
  styleUrls: ['./challenges.component.css']
})
export class ChallengesComponent implements OnInit {
  grid: Boolean = false;
  created = 0;
  recieved = 0;
  archived = 0;
  public = 0;
  tab = 1;
  challenges: Array<any> = [];
  url = this.apiservice.url + '/uploads/';
  noData: boolean = false;
  newchallenge = false;
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService
  ) { }

  ngOnInit() {
    this.loadCreated();
    this.loadRecieved(true);
    this.loadArchived(true);
    this.loadPublic(true);
    this.apiservice.getClient().subscribe((res: any) => {
      this.newchallenge = res.data.challenegestatus;
    });
  }

  changeTab(tab) {
    if (tab == 1) {
      this.loadCreated();
    } else if (tab == 2) {
      this.loadRecieved();
    } else if (tab == 3) {
      this.loadArchived();
    } else {
      this.loadPublic();
    }
  }

  loadPublic(status = false) {
    this.apiservice.getChallenges('public').subscribe((res: any) => {
      this.public = res.data.filter(data => !data.archivedBy.includes(this.apiservice.user._id)).length;
      if (!status) {
        this.noData = false;
        this.challenges = res.data.filter(data => !data.archivedBy.includes(this.apiservice.user._id));
        this.tab = 4;
        if (this.challenges.length == 0) {
          this.noData = true;
        }
      }
    })
  }


  loadCreated(status = false) {
    this.apiservice.getChallenges(this.apiservice.user._id).subscribe((res: any) => {
      this.created = res.data.length;
      if (!status) {
        this.noData = false;
        this.challenges = res.data;
        this.tab = 1;
        if (this.challenges.length == 0) {
          this.noData = true;
        }
      }
    })
  }

  loadRecieved(status = false) {
    this.apiservice.getRecievedChallenges(this.apiservice.user._id).subscribe((res: any) => {
      this.recieved = res.data.filter((data: any) => data.challenge).map((data: any) => data.challenge).length;
      if (!status) {
        this.noData = false;
        this.challenges = res.data.filter((data: any) => data.challenge).map((data: any) => data.challenge);
        this.tab = 2;
        if (this.challenges.length == 0) {
          this.noData = true;
        }
      }
    })
  }

  loadArchived(status = false) {
    this.apiservice.getArchivedChallenges(this.apiservice.user._id).subscribe((res: any) => {
      this.archived = res.data.length;
      if (!status) {
        this.noData = false;
        this.challenges = res.data;
        this.tab = 3;
        if (this.challenges.length == 0) {
          this.noData = true;
        }
      }
    });
  }

  formatDate(date) {
    return moment(date).format('LLL');
  }

  archiveChallenge(challenge) {
    if (this.tab !== 3) {
      challenge['archivedBy'].push(this.apiservice.user._id);
      this.apiservice.updateChallenge({ id: challenge._id, archivedBy: challenge['archivedBy'] }).subscribe(() => {
        if (this.tab == 1) {
          this.loadCreated();
          this.loadRecieved(true);
          this.loadArchived(true);
          this.loadPublic(true);
        } else if (this.tab == 2) {
          this.loadRecieved();
          this.loadPublic(true);
          this.loadCreated(true);
          this.loadArchived(true);
        } else if (this.tab == 4) {
          this.loadPublic();
          this.loadRecieved(true);
          this.loadArchived(true);
          this.loadCreated(true);
        }
      });
    }
  }

}
